import {
  Card,
  CardContent,
  Typography,
  Grid,
  Stack,
  Button,
  Box,
} from "@mui/material";

import { MY_PERF_SCROLL_LIST_PB } from "../../Dashboard/layouts";

export default function KeyInsightsCard({
  title = "Key Insights",
  patientTrendCount = 0,
  competitorDynamicsCount = 0,
  physicianBehaviourCount = 0,
  utEngagementCount = 0,
  onExplorePatientTrend,
  onExploreUtEngagement,
  onExploreCompetitorDynamics,
  onExplorePhysicianBehavior,
}) {
  const cards = [
    {
      key: "patientTrend",
      label: "PATIENT TREND",
      bg: "#FFC798",
      count: patientTrendCount,
      description: "HCPs/HCOs in your region observed patient trend changes.",
      buttonText: "Explore Patient Trend",
      onClick: onExplorePatientTrend,
    },
    {
      key: "competitorDynamics",
      label: "COMPETITOR DYNAMICS",
      bg: "#c5e9ca",
      count: competitorDynamicsCount,
      description: "HCPs in your region were impacted by competitor activity.",
      buttonText: "Explore Competitor Dynamics",
      onClick: onExploreCompetitorDynamics,
    },
    {
      key: "physicianBehaviour",
      label: "PHYSICIAN BEHAVIOUR",
      bg: "#f5d89c",
      count: physicianBehaviourCount,
      description: "HCPs in your region showed prescribing shifts.",
      buttonText: "Explore Physician Behaviour",
      onClick: onExplorePhysicianBehavior,
    },
    {
      key: "utEngagement",
      label: "UT ENGAGEMENT",
      bg: "#abd3e6",
      count: utEngagementCount,
      description: "Low-engagement notifications triggered this week.",
      buttonText: "Explore UT Engagement",
      onClick: onExploreUtEngagement,
    },
  ];

  return (
    <Card
      variant="outlined"
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        borderRadius: "8px",
        border: "0.5px solid #F0F0F0",
        boxShadow: "1px 4px 4px 0px #00000008",
      }}
    >
      <CardContent
        sx={{
          p: 3,
          flex: 1,
          minHeight: 0,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <Box sx={{ flexShrink: 0, mb: "20px" }}>
          <Typography
            variant="subtitle2"
            sx={{
              fontWeight: 600,
              fontSize: "14px",
              lineHeight: 1.2,
            }}
          >
            {title}
          </Typography>
        </Box>

        <Box
          sx={{
            flex: "1 1 0",
            minHeight: 0,
            maxHeight: 400,
            overflowY: "auto",
            pr: 0.5,
            pb: MY_PERF_SCROLL_LIST_PB,
          }}
        >
          <Grid container spacing={2} alignItems="stretch">
            {cards.map((item) => (
              <Grid item xs={12} sm={6} key={item.key}>
                <Stack sx={{ height: "100%", minHeight: 0 }}>
                  <Card
                    variant="outlined"
                    sx={{
                      borderRadius: 2,
                      p: 2,
                      backgroundColor: "#F7F9FB",
                      boxShadow: "1px 4px 4px 0px #00000008",
                      display: "flex",
                      flexDirection: "column",
                      height: "100%",
                      minHeight: 0,
                      overflow: "hidden",
                      "&:hover": {
                        borderColor: "#D96B04",
                      },
                      "&:hover .trend-button": {
                        backgroundColor: "#3a6e86",
                        color: "#fff",
                        borderColor: "#3a6e86",
                      },
                    }}
                  >
                    <Stack
                      sx={{
                        alignItems: "center",
                        flex: 1,
                        minHeight: 0,
                        gap: 1,
                      }}
                    >
                    {/* Title pill */}
                    <Typography
                      sx={{
                        backgroundColor: item.bg,
                        p: "8px 12px",
                        textAlign: "center",
                        minWidth: "103px",
                        borderRadius: "22px",
                        fontWeight: 700,
                        fontFamily: '"Helvetica Neue", Arial, sans-serif',
                        fontSize: "10px",
                      }}
                    >
                      {item.label}
                    </Typography>

                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flex: 1,
                        minHeight: 0,
                        minWidth: 0,
                        width: "100%",
                      }}
                    >
                      {/* Count */}
                      <Typography
                        sx={{
                          fontSize: "34px",
                          lineHeight: 1,
                          fontWeight: 700,
                          fontFamily: '"Helvetica Neue", Arial, sans-serif',
                          p: 1,
                        }}
                      >
                        {item.count}
                      </Typography>

                      {/* Description */}
                      <Typography
                        sx={{
                          fontSize: "10px",
                          px: 1,
                          flex: 1,
                          minWidth: 0,
                          lineHeight: 1.25,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          textAlign: "center",
                        }}
                      >
                        {item.description}
                      </Typography>
                    </Box>
                    <Button
                      variant="outlined"
                      className="trend-button"
                      sx={{
                        fontSize: "12px",
                        width: "100%",
                        flexShrink: 0,
                        fontFamily: '"Helvetica Neue", Arial, sans-serif',
                        fontWeight: 700,
                        textTransform: "none",
                        borderColor: "#3a6e86",
                        color: "black",
                        "&:hover": {
                          backgroundColor: "transparent",
                        },
                      }}
                      onClick={item.onClick}
                    >
                      {item.buttonText}
                    </Button>
                  </Stack>
                </Card>
              </Stack>
            </Grid>
          ))}
          </Grid>
        </Box>
      </CardContent>
    </Card>
  );
}
